<form class="" [formGroup]="_gestionTercerosService.customerForm">

    <div class="row" formGroupName="gestion">
        <div class="col-12">

            <div class="formInit_gestion">

                <div class="row pr-2 pl-3 justify-content-between altura1_7 ">

                    <div class="col-6" *ngIf="pais === 'es'">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 anchurax40 text-right">
                                {{ "gestion_terceros.gestion.FLDVatCode" | translate}} :</label>
                            <kendo-dropdownlist [data]="exemptions" [textField]="'Description'" [valueField]="'VatCode'"
                                                [valuePrimitive]="true" [popupSettings]="{ width: 190 }"
                                                formControlName="ExemptionVatCode"
                                                class="form-control anchurax50 float-right">
                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                    <span class="kendo_list_template">{{ dataItem.Description }}</span>
                                </ng-template>
                            </kendo-dropdownlist>
                        </div>
                    </div>
                    <div class="col-6" *ngIf="pais !== 'es'">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 anchurax40 text-right">
                                {{ "gestion_terceros.gestion.FLDExemptionVatCode" | translate}} :
                            </label>
                            <kendo-dropdownlist [data]="exemptions" [textField]="'Description'" [valueField]="'VatCode'"
                                                [valuePrimitive]="true" [popupSettings]="{ width: 190 }"
                                                formControlName="ExemptionVatCode"
                                                class="form-control anchurax50 float-right">
                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                    <span class="kendo_list_template">{{ dataItem.Description }}</span>
                                </ng-template>
                            </kendo-dropdownlist>
                        </div>
                    </div>
                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 text-right anchurax45">
                                {{"gestion_terceros.gestion.FLDESDiscountPR" | translate}} :
                            </label>

                            <kendo-dropdownlist [data]="discountPR" [textField]="'Description'"
                                                [valueField]="'DiscountCode'" (valueChange)="valueChange($event)"
                                                formControlName="DiscountPR"
                                                class="form-control anchurax50 float-right">
                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                    <span class="kendo_list_template">{{ dataItem.Description }}</span>
                                </ng-template>
                            </kendo-dropdownlist>
                        </div>
                    </div>

                </div>

                <div class="row pr-2 pl-3 justify-content-between altura1_7 ">
                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 anchurax40 text-right">
                                {{ "gestion_terceros.gestion.CodDtoMo" | translate }}:
                            </label>
                            <kendo-dropdownlist [popupSettings]="{ width: 190 }" [data]="discountMO"
                                                [textField]="'Description'" [valueField]="'DISCOUNTCODE'"
                                                [valuePrimitive]="true"
                                                formControlName="DiscountMO"
                                                class="form-control  float-right anchurax50 ">
                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                    <span class="kendo_list_template">{{ dataItem.Description }}</span>
                                </ng-template>
                            </kendo-dropdownlist>
                        </div>
                    </div>
                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion"
                             [ngClass]="{ 'popoverClassic_red': blurElementGestion('PriceMO')  }">
                            <label class="mt-1 text-right anchurax45">
                                {{ "gestion_terceros.gestion.PrecioMO" | translate }}:
                            </label>
                            <kendo-numerictextbox maxlength="12" popoverPlacement="bottom" [popoverOnHover]="true"
                                                  [popover]="myPopover18" [min]="min" [max]="max" [spinners]="false"
                                                  formControlName="PriceMO" [format]="formatOptionsEuros"
                                                  class="form-control  float-right anchurax50 altura1_5 ">
                            </kendo-numerictextbox>
                            <popover-content #myPopover18>
                                <div class="body-tooltip" *ngIf="blurElementGestion('PriceMO')">
                                    <span [innerHtml]="'errors.numberBig' | translate | returnHtml: 'html'"></span>
                                </div>
                            </popover-content>

                        </div>
                    </div>
                </div>


                <div class="row pr-2 pl-3 justify-content-between altura1_7 ">

                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 anchurax40 text-right">
                                {{"gestion_terceros.gestion.DescEspecial" | translate}} :
                            </label>

                            <!-- <input
                            [decimals]="2"
                            appDecimals
                            formControlName="SpecialDiscount"
                            type="text"
                            class="form-control  float-right anchurax50"
                          /> -->

                            <kendo-numerictextbox class="form-control float-right anchurax50" [format]="'n2'"
                                                  [step]="0.10" [min]="0" [max]="100" [autoCorrect]="true"
                                                  formControlName="SpecialDiscount">
                            </kendo-numerictextbox>
                        </div>
                    </div>

                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 text-right anchurax45">{{"labels.codContable" | translate}} :</label>


                            <input [ngClass]="{'form-error': getValueControl('AccountingCode')}"
                                   appDigitOnly maxlength="6" formControlName="AccountingCode" type="text"
                                   class="form-control  float-right anchurax50"/>
                        </div>
                    </div>
                </div>

                <div class="row  pr-2 pl-3 justify-content-between altura1_7 ">
                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="text-right anchurax40 text-not-over" title="{{ 'gestion_terceros.gestion.FLDESMandateReference' | translate}}">
                                {{"gestion_terceros.gestion.FLDESMandateReference" | translate}} :</label>
                            <input maxlength="35" formControlName="MandateReference" type="text"
                                   class="form-control  float-right anchurax50"/>
                        </div>
                    </div>
                    <div class="col-6 ">
                        <div class="form-group_terceros pr-2 datos_identificacion">
                            <label class="mt-1 text-not-over  anchurax45 float-left text-right" title="{{'gestion_terceros.gestion.FLDESMandateSigningDate' | translate}} ">
                                {{"gestion_terceros.gestion.FLDESMandateSigningDate" | translate}} :</label>
                            <div class="gestion anchurax50 float-right altura1_7 mb-1">
                                <calendario [formulario]="_gestionTercerosService.customerForm"
                                            [controlGroup]="'gestion'" [controlName]="'MandateSigningDate'">
                                </calendario>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ownerBox_withou_marging row mt-1">
                <h2>{{ "labels.credito" | translate }} :</h2>

                <div class="form-group_terceros col-4 datos_identificacion "
                     [ngClass]="{ 'popoverClassic_red': blurElementGestion('CreditLimit')  }">
                    <label class="mt-2">
                        {{"gestion_terceros.gestion.FLDESCreditLimit" | translate}}:
                    </label>

                    <kendo-numerictextbox popoverPlacement="bottom" [popoverOnHover]="true" [popover]="myPopover10"
                                          [min]="min" [max]="max" [spinners]="false" formControlName="CreditLimit"
                                          [format]="formatOptionsEuros"
                                          class="form-control  float-right anchurax50 altura1_5 ">
                    </kendo-numerictextbox>
                    <popover-content #myPopover10>
                        <div class="body-tooltip" *ngIf="blurElementGestion('CreditLimit')">
                            <span [innerHtml]="'errors.numberBig' | translate | returnHtml: 'html'"></span>
                        </div>
                    </popover-content>
                </div>

                <div class="form-group_terceros col-5 datos_identificacion only_reading mt-1">
                    <label class="mt-1">{{ "gestion_terceros.gestion.FLDESCreditSpent" | translate }} :
                    </label>

                    <kendo-numerictextbox disabled formControlName="CreditSpent" [spinners]="false"
                                          [format]="formatOptionsEuros"
                                          class="form-control  float-right anchurax50 altura1_5">
                    </kendo-numerictextbox>
                </div>

                <div class="form-group_terceros col-3 mt-1 reset">
                    <label class="cb check  mt-2">
                        <span class="cb-text mr-1">
                            {{   "gestion_terceros.gestion.FLDESCreditLocked" | translate }} :</span>
                        <input id="CreditLocked" type="checkbox" formControlName="CreditLocked"/>
                        <span class="cb-field"></span>
                    </label>
                </div>
            </div>

            <div class="row  pr-2 pl-2" formGroupName="Iban">
                <div class="col-12">
                    <div class="form-group_terceros pr-2 datos_identificacion">
                        <div class="row mt-1">
                            <div class="col-3">
                                <label
                                    class="mt-2 mr-1 float-right">{{"gestion_terceros.gestion.FLDIBANCode" | translate }}
                                    :</label>
                            </div>
                            <div class="col-9">
                                <div class="row p-1">
                                    <div class="col-2 popoverClassic_white">
                                        <kendo-dropdownlist (change)="ibanValidation()" popoverPlacement="top"
                                                            [popoverOnHover]="true"
                                                            [popover]="myPopover1" [data]="newBanks"
                                                            [textField]="'bankName'"
                                                            [valueField]="'bankName'" [valuePrimitive]="true"
                                                            formControlName="Country"
                                                            class="form-control mr-1" [popupSettings]="{ width: 100 }">
                                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                <span class="template">{{ dataItem?.bankName }}</span>
                                            </ng-template>
                                        </kendo-dropdownlist>
                                        <popover-content #myPopover1>
                                            <div class="body-tooltip rem5">
                                                <span
                                                    [innerHtml]="'gestion_terceros.popover.codPais' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>

                                    <div class="col-1 reset popoverClassic_white ">
                                        <input (change)="ibanValidation()" (paste)="ibanValidation()"
                                               [ngClass]="{  'form-error':!_gestionTercerosService.isValidIban}"
                                               maxlength="2" appDigitOnly (blur)="escribirCeros('CheckDigit')"
                                               popoverPlacement="top" [popoverOnHover]="true" [popover]="myPopover2"
                                               formControlName="CheckDigit" type="text"
                                               class="text-center form-control anchurax75 ml-1 float-left bank"/>
                                        <popover-content #myPopover2>
                                            <div class="body-tooltip rem10">
                                                <span
                                                    [innerHtml]=" 'gestion_terceros.popover.ayudaIban.checkiban'| translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>

                                    <div class="col-1 popoverClassic_white reset">
                                        <input (change)="ibanValidation()" (paste)="ibanValidation()"
                                               [ngClass]="{'form-error':!_gestionTercerosService.isValidIban}"
                                               maxlength="4" appDigitOnly
                                               (blur)="escribirCeros('BankCode')" popoverPlacement="top"
                                               [popoverOnHover]="true" [popover]="myPopover3" formControlName="BankCode"
                                               type="text" class="text-center form-control float-left anchurax85 bank"/>
                                        <popover-content #myPopover3>
                                            <div class="body-tooltip rem15">
                                                <span
                                                    [innerHtml]="'gestion_terceros.popover.ayudaIban' | translate| returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>
                                    <div class="col-1 popoverClassic_white reset">
                                        <input (change)="ibanValidation()" (paste)="ibanValidation()"
                                               [ngClass]="{'form-error':!_gestionTercerosService.isValidIban}"
                                               maxlength="4" appDigitOnly
                                               (blur)="escribirCeros('BranchCode')" popoverPlacement="top"
                                               [popoverOnHover]="true" [popover]="myPopover4"
                                               formControlName="BranchCode"
                                               type="text"
                                               class="ml-1 text-center form-control anchurax85 float-left bank"/>
                                        <popover-content #myPopover4>
                                            <div class="body-tooltip rem10">
                                                <span
                                                    [innerHtml]="'gestion_terceros.popover.ayudaIban.S' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>

                                    <div class="col-1 popoverClassic_white reset">
                                        <input (change)="ibanValidation()" (paste)="ibanValidation()"
                                               [ngClass]="{'form-error':!_gestionTercerosService.isValidIban}"
                                               maxlength="2" appDigitOnly
                                               (blur)="escribirCeros('NationalCheckDigit')" popoverPlacement="top"
                                               [popoverOnHover]="true" [popover]="myPopover5"
                                               formControlName="NationalCheckDigit" type="text"
                                               class="ml-2 text-center form-control anchurax70 float-left bank"/>
                                        <popover-content #myPopover5>
                                            <div class="body-tooltip rem15">
                                                <span
                                                    [innerHtml]="'gestion_terceros.popover.ayudaIban.X' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>
                                    <div class="col-2 popoverClassic_white reset">
                                        <input (change)="ibanValidation()" (paste)="ibanValidation()"
                                               [ngClass]="{'form-error':!_gestionTercerosService.isValidIban}"
                                               maxlength="10" appDigitOnly
                                               (blur)="escribirCeros('AccountNumber')" popoverPlacement="top"
                                               [popoverOnHover]="true" [popover]="myPopover6"
                                               formControlName="AccountNumber" type="text"
                                               class="text-center form-control  float-left bank"/>
                                        <popover-content #myPopover6>
                                            <div class="body-tooltip rem10">
                                                <span
                                                    [innerHtml]="'gestion_terceros.popover.ayudaIban.C' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>
                                    <div class="col-1 mr-1 popoverClassic popoverClassic_4">
                                        <span appCurrentColor [backgroundColor]="true"
                                              class="only_exclamation k-icon k-i-question"
                                              popoverPlacement="top" [popoverOnHover]="true"
                                              [popoverCloseOnClickOutside]="true"
                                              [popover]="myPopover0" role="button">
                                        </span>
                                        <popover-content #myPopover0 [closeOnClickOutside]="true">
                                            <div class="body-tooltip popover_mod_2 mod1">
                                                <span
                                                    [innerHtml]="'gestion_terceros.popover.ayudaIbanCompleted' | translate | returnHtml: 'html'">
                                                </span>
                                            </div>
                                        </popover-content>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pr-2 pl-2">
                <div class="col-6">
                    <div class="form-group_terceros pr-2 datos_identificacion">
                        <label title="{{'gestion_terceros.gestion.FLDPaymentCode' | translate}} "
                               class="mt-1 anchurax45 text-right text-not-over">
                            {{"gestion_terceros.gestion.FLDPaymentCode" | translate}} :
                        </label>
                        <kendo-dropdownlist [data]="modePaid" [textField]="'Description'" [valueField]="'PAYMENTCODE'"
                                            [valuePrimitive]="true" formControlName="PaymentCode"
                                            [popupSettings]="{ width: 250 }"
                                            class="form-control  float-right anchurax45">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.Description }}</span>
                            </ng-template>
                        </kendo-dropdownlist>
                    </div>
                </div>
                <div class="col-6 reset">
                    <div class="form-group_terceros pr-2 datos_identificacion">
                        <div [ngClass]="{ 'popoverClassic_red': blurElementGestion('PaymentDay1')  }">
                            <label class="mt-1 float-left">{{ "gestion_terceros.gestion.FLDESPaymentDay" | translate}}:</label>
                            <kendo-numerictextbox popoverPlacement="bottom" [popoverOnHover]="true"
                                                  [popover]="myPopover21" [format]="'n'" [min]="0" [max]="31"
                                                  [spinners]="false"
                                                  formControlName="PaymentDay1"
                                                  class="ml-1 form-control float-left anchurax30">
                            </kendo-numerictextbox>
                            <popover-content #myPopover21>
                                <div class="body-tooltip" *ngIf="blurElementGestion('PaymentDay1')">
                                    <span [innerHtml]="'errors.fechaCorrecta' | translate | returnHtml: 'html'"></span>
                                </div>
                            </popover-content>
                        </div>
                        <div [ngClass]="{ 'popoverClassic_red': blurElementGestion('PaymentDay2')  }">
                            <kendo-numerictextbox popoverPlacement="bottom" [popoverOnHover]="true"
                                                  [popover]="myPopover20" [format]="'n'" [min]="0" [max]="31"
                                                  [spinners]="false"
                                                  formControlName="PaymentDay2"
                                                  class="ml-1 form-control float-left anchurax30">
                            </kendo-numerictextbox>
                            <popover-content #myPopover20>
                                <div class="body-tooltip" *ngIf="blurElementGestion('PaymentDay2')">
                                    <span [innerHtml]="'errors.fechaCorrecta' | translate | returnHtml: 'html'"></span>
                                </div>
                            </popover-content>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row borde_gris_b ml-2 m-0 mb-0">
                <label class="text-bold altura1_5 line-height-2">
                    {{"gestion_terceros.gestion.montoPermitidoParaPagosParciales" | translate}}: </label>

                <div class="col-6 float-left mt-1 altura1_7 ">
                    <label class="mt-1">{{ "gestion_terceros.gestion.saldo" | translate }} : </label>
                    <kendo-numerictextbox [spinners]="false" formControlName="AmountPendingCashPayments" disabled
                                          [format]="formatOptionsEuros"
                                          class="form-control  float-right anchurax55 altura1_5">
                    </kendo-numerictextbox>
                </div>

            </div>


        </div>
    </div>
</form>
